import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import InvestmentRateChangeCriteria from "./RateChangeCriteria";

@NeoReport("InvestmentRateChange", { category: ReportCategory.InvestorReports })
export default class InvestmentRateChangeReport extends Report<InvestmentRateChangeCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache),
        public investorApiClient = AppService.get(DomainTypes.ApiClients.Investor)) {
        super(InvestmentRateChangeCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.entityId}
                  select={{ itemSource: this.dataCache.entities, allowNulls: true }}
                  label="Entity" />

                <Neo.FormGroup bind={this.criteria.meta.interestRateTypeId}
                  select={{ itemSource: this.dataCache.interestRateTypes }}
                  label="Interest Rate Type" />
            </Neo.GridLayout>
        </div>;
    }
}